var $ = require('jQuery');
var Vue = require('vue');
var Multiselect = require('vue-bootstrap').Multiselect;
var JudgeSelector = require('@/lib/components/Judging/JudgeSelector.vue').default;
var FormDisabler = require('../../lib/form-disabler.js');

module.exports = function () {
  // Category selector
  new Vue({
    el: '#category-selector',
    components: {
      'multiselect': Multiselect
    }
  });

  // Judge selector
  new Vue({
    el: '#judge-selector',
    components: {
      'judge-selector': JudgeSelector
    }
  });

  // Load score sets
  var scoreSets = scoreSetMap.clarify();

  // Refresh the score set selector.
  var refreshScoreSets = function () {
    // Load selected mode
    var mode = $('.mode-selector:checked').val();

    if (!mode) {
      return;
    }

    // Load selector and current value
    var selector = $('#scoreSetId');
    var value = selector.val();

    // Empty and populate
    selector.empty();

    // Populate if any
    if (scoreSets[mode] !== undefined) {
      for (var i in scoreSets[mode]) {
        selector.append($('<option>', scoreSets[mode][i]));
      }

      // Reset the current value
      selector.val(value);

      if (!selector.val()) {
        selector.val(scoreSets[mode][0].val);
      }
    }
  };

  //
  var refreshRounds = function () {
    // Load selected mode
    var mode = $('.mode-selector:checked').val();

    if (!mode) {
      return;
    }

    if (mode == 'gallery') {
      $('#when').hide();
    } else {
      $('#when').show();
    }
  };

  // Bind change events
  $('.mode-selector').on('change', refreshScoreSets);
  $('.mode-selector').on('change', refreshRounds);

  // Refresh on load.
  refreshScoreSets();
  refreshRounds();

  (new FormDisabler()).disableForm($('.form-disabled'));
};
